var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ad-group-page" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
      _c(
        "div",
        { staticClass: "page-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-back" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c(
          "el-skeleton",
          { attrs: { loading: _vm.isEdit && _vm.loading, animated: "" } },
          [
            _c("template", { slot: "template" }, [
              _c(
                "div",
                { staticStyle: { padding: "20px" } },
                [
                  _c("el-skeleton-item", {
                    staticStyle: { width: "30%", height: "40px" },
                    attrs: { variant: "text" },
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "margin-top": "20px" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "70%" } },
                        [
                          _c("el-skeleton-item", {
                            staticStyle: {
                              "margin-bottom": "10px",
                              height: "30px",
                            },
                            attrs: { variant: "text" },
                          }),
                          _c("el-skeleton-item", {
                            staticStyle: {
                              "margin-bottom": "10px",
                              height: "30px",
                            },
                            attrs: { variant: "text" },
                          }),
                          _c("el-skeleton-item", {
                            staticStyle: {
                              "margin-bottom": "10px",
                              height: "30px",
                            },
                            attrs: { variant: "text" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "30%" } },
                        [
                          _c("el-skeleton-item", {
                            staticStyle: { width: "100%", height: "200px" },
                            attrs: { variant: "image" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            [
              _c("AdGroupEditor", {
                attrs: {
                  "edit-data": _vm.adGroupData,
                  "is-edit": _vm.isEdit,
                  "is-simple-mode": false,
                },
                on: { success: _vm.handleSuccess },
              }),
            ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }